var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatapointsRafiki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,127.67a11.33,11.33,0,0,0-14.59-10.86,23.36,23.36,0,0,0,.26-3.48,24,24,0,0,0-28.42-23.58,21,21,0,0,0-38.9,10.6l-.35,0A19.34,19.34,0,0,0,125,139h71v0A11.32,11.32,0,0,0,207,127.67Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,178.37a5.63,5.63,0,0,0-5.63-5.63,5.82,5.82,0,0,0-1.62.24,11,11,0,0,0,.13-1.73A11.92,11.92,0,0,0,266,159.33a11.47,11.47,0,0,0-2.2.21,10.42,10.42,0,0,0-19.32,5.26h-.17a9.61,9.61,0,0,0,0,19.21h35.26A5.62,5.62,0,0,0,285,178.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.5,123.55a3.45,3.45,0,0,0-3.45-3.45,3.65,3.65,0,0,0-1,.15,7.45,7.45,0,0,0,.08-1.06,7.3,7.3,0,0,0-7.3-7.3,7.53,7.53,0,0,0-1.35.12,6.38,6.38,0,0,0-11.83,3.23h-.11a5.89,5.89,0,0,0,0,11.77h21.6A3.46,3.46,0,0,0,409.5,123.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(135 112.98)",
    style: {
      writingMode: "tb",
      textOrientation: "upright",
      glyphOrientationVertical: "0deg",
      fontSize: 7,
      fill: "#ebebeb",
      fontFamily: "Bebas"
    }
  }, "101010000111110101010101"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(142.5 112.98)",
    style: {
      writingMode: "tb",
      textOrientation: "upright",
      glyphOrientationVertical: "0deg",
      fontSize: 7,
      fill: "#ebebeb",
      fontFamily: "Bebas"
    }
  }, "001101100110001101011111"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(150 112.98)",
    style: {
      writingMode: "tb",
      textOrientation: "upright",
      glyphOrientationVertical: "0deg",
      fontSize: 7,
      fill: "#ebebeb",
      fontFamily: "Bebas"
    }
  }, "111110101010101011110000"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(157.5 112.98)",
    style: {
      writingMode: "tb",
      textOrientation: "upright",
      glyphOrientationVertical: "0deg",
      fontSize: 7,
      fill: "#ebebeb",
      fontFamily: "Bebas"
    }
  }, "101010000111110101010101"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(165 112.98)",
    style: {
      writingMode: "tb",
      textOrientation: "upright",
      glyphOrientationVertical: "0deg",
      fontSize: 7,
      fill: "#ebebeb",
      fontFamily: "Bebas"
    }
  }, "000101011111000000110101"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(172.5 112.98)",
    style: {
      writingMode: "tb",
      textOrientation: "upright",
      glyphOrientationVertical: "0deg",
      fontSize: 7,
      fill: "#ebebeb",
      fontFamily: "Bebas"
    }
  }, "110011001101010101001100"), /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 238.65,
    width: 226.51,
    height: 144.08,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 238.65,
    width: 226.51,
    height: 9.76,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.64,243.53a2.94,2.94,0,1,1-2.94-2.94A2.94,2.94,0,0,1,268.64,243.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.87,243.53a2.94,2.94,0,1,1-2.94-2.94A2.95,2.95,0,0,1,258.87,243.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.09,243.53a2.94,2.94,0,1,1-2.94-2.94A2.94,2.94,0,0,1,249.09,243.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.46,265.34l-1.39-1.94a2.71,2.71,0,0,0-2.17-1.14H73.07a2.36,2.36,0,0,0-2,1.14l-1.17,1.94a2.36,2.36,0,0,1-2,1.14H62A2.38,2.38,0,0,0,59.57,269l1.9,32.81a2.73,2.73,0,0,0,2.68,2.56h46.47a2.38,2.38,0,0,0,2.38-2.56L111.1,269a2.72,2.72,0,0,0-2.67-2.55H88.63A2.71,2.71,0,0,1,86.46,265.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.07,269.6H70.5a3.57,3.57,0,0,0-3.5,3.19l-2.56,28.42a2.88,2.88,0,0,0,2.92,3.19h42.58a3.58,3.58,0,0,0,3.5-3.19L116,272.79A2.88,2.88,0,0,0,113.07,269.6Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.35,265.34,156,263.4a2.71,2.71,0,0,0-2.17-1.14H144a2.37,2.37,0,0,0-2,1.14l-1.17,1.94a2.36,2.36,0,0,1-2,1.14h-5.86a2.38,2.38,0,0,0-2.39,2.55l1.9,32.81A2.73,2.73,0,0,0,135,304.4h46.47a2.37,2.37,0,0,0,2.38-2.56L182,269a2.74,2.74,0,0,0-2.68-2.55H159.53A2.71,2.71,0,0,1,157.35,265.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,269.6H141.39a3.57,3.57,0,0,0-3.5,3.19l-2.56,28.42a2.88,2.88,0,0,0,2.93,3.19h42.57a3.58,3.58,0,0,0,3.5-3.19l2.56-28.42A2.88,2.88,0,0,0,184,269.6Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,265.34l-1.4-1.94a2.69,2.69,0,0,0-2.17-1.14h-9.83a2.37,2.37,0,0,0-2,1.14l-1.17,1.94a2.36,2.36,0,0,1-2,1.14h-5.86a2.36,2.36,0,0,0-2.38,2.55l1.89,32.81a2.75,2.75,0,0,0,2.68,2.56H252.4a2.38,2.38,0,0,0,2.39-2.56L252.89,269a2.72,2.72,0,0,0-2.68-2.55H230.42A2.69,2.69,0,0,1,228.25,265.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.85,269.6H212.28a3.58,3.58,0,0,0-3.5,3.19l-2.56,28.42a2.88,2.88,0,0,0,2.93,3.19h42.57a3.58,3.58,0,0,0,3.5-3.19l2.56-28.42A2.88,2.88,0,0,0,254.85,269.6Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.46,325.38l-1.39-1.94a2.71,2.71,0,0,0-2.17-1.14H73.07a2.36,2.36,0,0,0-2,1.14l-1.17,1.94a2.36,2.36,0,0,1-2,1.14H62a2.38,2.38,0,0,0-2.39,2.55l1.9,32.81a2.72,2.72,0,0,0,2.68,2.55h46.47a2.37,2.37,0,0,0,2.38-2.55l-1.9-32.81a2.72,2.72,0,0,0-2.67-2.55H88.63A2.71,2.71,0,0,1,86.46,325.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.07,329.64H70.5a3.57,3.57,0,0,0-3.5,3.19l-2.56,28.42a2.87,2.87,0,0,0,2.92,3.18h42.58a3.57,3.57,0,0,0,3.5-3.18L116,332.83A2.88,2.88,0,0,0,113.07,329.64Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.35,325.38,156,323.44a2.71,2.71,0,0,0-2.17-1.14H144a2.37,2.37,0,0,0-2,1.14l-1.17,1.94a2.36,2.36,0,0,1-2,1.14h-5.86a2.38,2.38,0,0,0-2.39,2.55l1.9,32.81a2.72,2.72,0,0,0,2.68,2.55h46.47a2.36,2.36,0,0,0,2.38-2.55L182,329.07a2.74,2.74,0,0,0-2.68-2.55H159.53A2.71,2.71,0,0,1,157.35,325.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,329.64H141.39a3.57,3.57,0,0,0-3.5,3.19l-2.56,28.42a2.87,2.87,0,0,0,2.93,3.18h42.57a3.57,3.57,0,0,0,3.5-3.18l2.56-28.42A2.88,2.88,0,0,0,184,329.64Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,325.38l-1.4-1.94a2.69,2.69,0,0,0-2.17-1.14h-9.83a2.37,2.37,0,0,0-2,1.14l-1.17,1.94a2.36,2.36,0,0,1-2,1.14h-5.86a2.36,2.36,0,0,0-2.38,2.55l1.89,32.81a2.74,2.74,0,0,0,2.68,2.55H252.4a2.38,2.38,0,0,0,2.39-2.55l-1.9-32.81a2.72,2.72,0,0,0-2.68-2.55H230.42A2.69,2.69,0,0,1,228.25,325.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.85,329.64H212.28a3.58,3.58,0,0,0-3.5,3.19l-2.56,28.42a2.87,2.87,0,0,0,2.93,3.18h42.57a3.57,3.57,0,0,0,3.5-3.18l2.56-28.42A2.88,2.88,0,0,0,254.85,329.64Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.36,
    y: 359.16,
    width: 78.33,
    height: 23,
    rx: 2.67,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,370.66a4.83,4.83,0,1,1-4.83-4.83A4.84,4.84,0,0,1,445,370.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.59,370.66a2.46,2.46,0,1,1-2.46-2.46A2.46,2.46,0,0,1,442.59,370.66Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.27,
    y: 367.91,
    width: 5.5,
    height: 5.5,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.36,
    y: 335.16,
    width: 78.33,
    height: 23,
    rx: 2.67,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,346.66a4.83,4.83,0,1,1-4.83-4.83A4.84,4.84,0,0,1,445,346.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.59,346.66a2.46,2.46,0,1,1-2.46-2.46A2.46,2.46,0,0,1,442.59,346.66Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.27,
    y: 343.91,
    width: 5.5,
    height: 5.5,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.36,
    y: 311.16,
    width: 78.33,
    height: 23,
    rx: 2.67,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,322.66a4.83,4.83,0,1,1-4.83-4.83A4.84,4.84,0,0,1,445,322.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.59,322.66a2.46,2.46,0,1,1-2.46-2.46A2.46,2.46,0,0,1,442.59,322.66Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.27,
    y: 319.91,
    width: 5.5,
    height: 5.5,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.36,
    y: 287.16,
    width: 78.33,
    height: 23,
    rx: 2.67,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,298.66a4.83,4.83,0,1,1-4.83-4.83A4.84,4.84,0,0,1,445,298.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.59,298.66a2.46,2.46,0,1,1-2.46-2.46A2.46,2.46,0,0,1,442.59,298.66Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.27,
    y: 295.91,
    width: 5.5,
    height: 5.5,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.36,
    y: 263.16,
    width: 78.33,
    height: 23,
    rx: 2.67,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,274.66a4.83,4.83,0,1,1-4.83-4.83A4.84,4.84,0,0,1,445,274.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.59,274.66a2.46,2.46,0,1,1-2.46-2.46A2.46,2.46,0,0,1,442.59,274.66Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.27,
    y: 271.91,
    width: 5.5,
    height: 5.5,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.36,
    y: 239.16,
    width: 78.33,
    height: 23,
    rx: 2.67,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,250.66a4.83,4.83,0,1,1-4.83-4.83A4.84,4.84,0,0,1,445,250.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.59,250.66a2.46,2.46,0,1,1-2.46-2.46A2.46,2.46,0,0,1,442.59,250.66Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.27,
    y: 247.91,
    width: 5.5,
    height: 5.5,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-4",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.54,357.18c-1.56-2.57-4.12-.34-4.12-.34.37-4.91-4.15-8.26-4.15-8.26s5.25,0,6-5-1.83-2.67-4.23-2.71-4.91,7-1.75,10.93,2.32,10.69-5,17.17a14.27,14.27,0,0,0-3.82,6c.55-5.95.86-14.34-.89-19.94-3-9.51,2.7-12.07,4.34-16.83s-4.34-8.78-4.34-8.78,5.62-2.56,2.88-5.49S80,321.36,80,325.18s3.85,5.29,3.85,5.29,4.39,4.57,4.39,6.95-4.39,7.5-4.39,7.5,2-4.38-2-4.57-5.3,5.12-3.66,7.5,4.39.36,4.39.36a46.27,46.27,0,0,0,1.26,8.23c.41,1.37.22,6.74-.13,12.32a13.83,13.83,0,0,0-3.56-5.29c-7.32-6.48-8.16-13.22-5-17.16s.66-11-1.74-10.94-5-2.29-4.23,2.72,6,5,6,5-4.51,3.36-4.15,8.26c0,0-2.56-2.22-4.11.34-2.78,4.57,3.66,7.41,4.74,5.16,0,0,13.64,9.65,10.35,23.56l.76,1.13c-.09,1.12-.16,1.79-.16,1.79l1.07-.46,1.22,1.8a40.21,40.21,0,0,0,.31,6l3.26-4.82C85.16,372,98.8,362.33,98.8,362.33,99.88,364.58,106.32,361.75,103.54,357.18Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.54,357.18c-1.56-2.57-4.12-.34-4.12-.34.37-4.91-4.15-8.26-4.15-8.26s5.25,0,6-5-1.83-2.67-4.23-2.71-4.91,7-1.75,10.93,2.32,10.69-5,17.17a14.27,14.27,0,0,0-3.82,6c.55-5.95.86-14.34-.89-19.94-3-9.51,2.7-12.07,4.34-16.83s-4.34-8.78-4.34-8.78,5.62-2.56,2.88-5.49S80,321.36,80,325.18s3.85,5.29,3.85,5.29,4.39,4.57,4.39,6.95-4.39,7.5-4.39,7.5,2-4.38-2-4.57-5.3,5.12-3.66,7.5,4.39.36,4.39.36a46.27,46.27,0,0,0,1.26,8.23c.41,1.37.22,6.74-.13,12.32a13.83,13.83,0,0,0-3.56-5.29c-7.32-6.48-8.16-13.22-5-17.16s.66-11-1.74-10.94-5-2.29-4.23,2.72,6,5,6,5-4.51,3.36-4.15,8.26c0,0-2.56-2.22-4.11.34-2.78,4.57,3.66,7.41,4.74,5.16,0,0,13.64,9.65,10.35,23.56l.76,1.13c-.09,1.12-.16,1.79-.16,1.79l1.07-.46,1.22,1.8a40.21,40.21,0,0,0,.31,6l3.26-4.82C85.16,372,98.8,362.33,98.8,362.33,99.88,364.58,106.32,361.75,103.54,357.18Z",
    style: {
      fill: "#5F95FA",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.54,357.18c-1.56-2.57-4.12-.34-4.12-.34.37-4.91-4.15-8.26-4.15-8.26s5.25,0,6-5-1.83-2.67-4.23-2.71-4.91,7-1.75,10.93,2.32,10.69-5,17.17a14.27,14.27,0,0,0-3.82,6c.55-5.95.86-14.34-.89-19.94-3-9.51,2.7-12.07,4.34-16.83s-4.34-8.78-4.34-8.78,5.62-2.56,2.88-5.49S80,321.36,80,325.18s3.85,5.29,3.85,5.29,4.39,4.57,4.39,6.95-4.39,7.5-4.39,7.5,2-4.38-2-4.57-5.3,5.12-3.66,7.5,4.39.36,4.39.36a46.27,46.27,0,0,0,1.26,8.23c.41,1.37.22,6.74-.13,12.32a13.83,13.83,0,0,0-3.56-5.29c-7.32-6.48-8.16-13.22-5-17.16s.66-11-1.74-10.94-5-2.29-4.23,2.72,6,5,6,5-4.51,3.36-4.15,8.26c0,0-2.56-2.22-4.11.34-2.78,4.57,3.66,7.41,4.74,5.16,0,0,13.64,9.65,10.35,23.56l.76,1.13c-.09,1.12-.16,1.79-.16,1.79l1.07-.46,1.22,1.8a40.21,40.21,0,0,0,.31,6l3.26-4.82C85.16,372,98.8,362.33,98.8,362.33,99.88,364.58,106.32,361.75,103.54,357.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.54,357.18c-1.56-2.57-4.12-.34-4.12-.34.37-4.91-4.15-8.26-4.15-8.26s5.25,0,6-5-1.83-2.67-4.23-2.71-4.91,7-1.75,10.93,2.32,10.69-5,17.17a14.27,14.27,0,0,0-3.82,6c.55-5.95.86-14.34-.89-19.94-3-9.51,2.7-12.07,4.34-16.83s-4.34-8.78-4.34-8.78,5.62-2.56,2.88-5.49S80,321.36,80,325.18s3.85,5.29,3.85,5.29,4.39,4.57,4.39,6.95-4.39,7.5-4.39,7.5,2-4.38-2-4.57-5.3,5.12-3.66,7.5,4.39.36,4.39.36a46.27,46.27,0,0,0,1.26,8.23c.41,1.37.22,6.74-.13,12.32a13.83,13.83,0,0,0-3.56-5.29c-7.32-6.48-8.16-13.22-5-17.16s.66-11-1.74-10.94-5-2.29-4.23,2.72,6,5,6,5-4.51,3.36-4.15,8.26c0,0-2.56-2.22-4.11.34-2.78,4.57,3.66,7.41,4.74,5.16,0,0,13.64,9.65,10.35,23.56l.76,1.13c-.09,1.12-.16,1.79-.16,1.79l1.07-.46,1.22,1.8a40.21,40.21,0,0,0,.31,6l3.26-4.82C85.16,372,98.8,362.33,98.8,362.33,99.88,364.58,106.32,361.75,103.54,357.18Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "100.87 416.48 69.62 416.48 66.25 382.26 104.24 382.26 100.87 416.48",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.87 416.48 69.62 416.48 66.25 382.26 104.24 382.26 100.87 416.48",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.58,
    y: 378.48,
    width: 41.33,
    height: 7.55,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.58,
    y: 378.48,
    width: 41.33,
    height: 7.55,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.87,377.42l-1.4-1.94a2.68,2.68,0,0,0-2.17-1.13h-9.82a2.37,2.37,0,0,0-2.05,1.13l-1.17,1.94a2.35,2.35,0,0,1-2,1.14h-5.86a2.37,2.37,0,0,0-2.38,2.55l1.9,32.81a2.73,2.73,0,0,0,2.67,2.56H412a2.38,2.38,0,0,0,2.39-2.56l-1.9-32.81a2.72,2.72,0,0,0-2.68-2.55H390A2.69,2.69,0,0,1,387.87,377.42Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.87,377.42l-1.4-1.94a2.68,2.68,0,0,0-2.17-1.13h-9.82a2.37,2.37,0,0,0-2.05,1.13l-1.17,1.94a2.35,2.35,0,0,1-2,1.14h-5.86a2.37,2.37,0,0,0-2.38,2.55l1.9,32.81a2.73,2.73,0,0,0,2.67,2.56H412a2.38,2.38,0,0,0,2.39-2.56l-1.9-32.81a2.72,2.72,0,0,0-2.68-2.55H390A2.69,2.69,0,0,1,387.87,377.42Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.47,381.69H371.9a3.57,3.57,0,0,0-3.5,3.18l-2.56,28.42a2.88,2.88,0,0,0,2.93,3.19h42.57a3.57,3.57,0,0,0,3.5-3.19l2.56-28.42A2.87,2.87,0,0,0,414.47,381.69Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.47,381.69H371.9a3.57,3.57,0,0,0-3.5,3.18l-2.56,28.42a2.88,2.88,0,0,0,2.93,3.19h42.57a3.57,3.57,0,0,0,3.5-3.19l2.56-28.42A2.87,2.87,0,0,0,414.47,381.69Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--data-storage--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.12,
    y: 366.67,
    width: 60.76,
    height: 42.43,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.79,
    y: 402.26,
    width: 48.4,
    height: 14.21,
    rx: 1.65,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.79,
    y: 402.26,
    width: 48.4,
    height: 14.21,
    rx: 1.65,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.3,
    y: 402.26,
    width: 48.4,
    height: 14.21,
    rx: 1.65,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.93,409.37a3,3,0,1,1-3-3A3,3,0,0,1,271.93,409.37Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.95,
    cy: 409.37,
    r: 1.52,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.15,
    y: 407.67,
    width: 3.4,
    height: 3.4,
    style: {
      fill: "#f5f5f5",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.79,
    y: 387.43,
    width: 48.4,
    height: 14.21,
    rx: 1.65,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.79,
    y: 387.43,
    width: 48.4,
    height: 14.21,
    rx: 1.65,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.3,
    y: 387.43,
    width: 48.4,
    height: 14.21,
    rx: 1.65,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.93,394.53a3,3,0,1,1-3-3A3,3,0,0,1,271.93,394.53Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.46,394.53A1.52,1.52,0,1,1,269,393,1.52,1.52,0,0,1,270.46,394.53Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.15,
    y: 392.83,
    width: 3.4,
    height: 3.4,
    style: {
      fill: "#f5f5f5",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.79,
    y: 372.59,
    width: 48.4,
    height: 14.21,
    rx: 1.65,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.79,
    y: 372.59,
    width: 48.4,
    height: 14.21,
    rx: 1.65,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.3,
    y: 372.59,
    width: 48.4,
    height: 14.21,
    rx: 1.65,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.93,379.69a3,3,0,1,1-3-3A3,3,0,0,1,271.93,379.69Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.46,379.69a1.52,1.52,0,1,1-1.51-1.52A1.52,1.52,0,0,1,270.46,379.69Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.15,
    y: 377.99,
    width: 3.4,
    height: 3.4,
    style: {
      fill: "#f5f5f5",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.79,
    y: 357.75,
    width: 48.4,
    height: 14.21,
    rx: 1.65,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.79,
    y: 357.75,
    width: 48.4,
    height: 14.21,
    rx: 1.65,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.3,
    y: 357.75,
    width: 48.4,
    height: 14.21,
    rx: 1.65,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.93,364.85a3,3,0,1,1-3-3A3,3,0,0,1,271.93,364.85Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.46,364.85a1.52,1.52,0,1,1-1.51-1.52A1.52,1.52,0,0,1,270.46,364.85Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.15,
    y: 363.15,
    width: 3.4,
    height: 3.4,
    style: {
      fill: "#f5f5f5",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.54,
    y: 389.32,
    width: 60.76,
    height: 19.77,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.2,
    y: 402.26,
    width: 48.4,
    height: 14.21,
    rx: 1.65,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.2,
    y: 402.26,
    width: 48.4,
    height: 14.21,
    rx: 1.65,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.72,
    y: 402.26,
    width: 48.4,
    height: 14.21,
    rx: 1.65,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.34,409.37a3,3,0,1,1-3-3A3,3,0,0,1,326.34,409.37Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.88,409.37a1.52,1.52,0,1,1-1.52-1.52A1.52,1.52,0,0,1,324.88,409.37Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.56,
    y: 407.67,
    width: 3.4,
    height: 3.4,
    style: {
      fill: "#f5f5f5",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.2,
    y: 387.43,
    width: 48.4,
    height: 14.21,
    rx: 1.65,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.2,
    y: 387.43,
    width: 48.4,
    height: 14.21,
    rx: 1.65,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.72,
    y: 387.43,
    width: 48.4,
    height: 14.21,
    rx: 1.65,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.34,394.53a3,3,0,1,1-3-3A3,3,0,0,1,326.34,394.53Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.88,394.53a1.52,1.52,0,1,1-1.52-1.52A1.52,1.52,0,0,1,324.88,394.53Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.56,
    y: 392.83,
    width: 3.4,
    height: 3.4,
    style: {
      fill: "#f5f5f5",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "169.34 399.09 163.04 400.21 160.45 391.61 158.09 383.71 165.36 381.17 167.47 390.66 169.34 399.09",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.51 390.85 160.48 391.78 158.1 383.8 165.37 381.22 167.51 390.85",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.23 402 120.83 402 119.78 392.98 118.83 384.74 126.43 383.48 126.86 393.28 127.23 402",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.86 393.36 119.78 393.05 118.83 384.78 126.43 383.5 126.86 393.36",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.92,414.69a10.55,10.55,0,0,0-3.42-1.86h0s-3.72-3.69-5.51-14.8l-4.87-1.27a4.14,4.14,0,0,0-4.43,1.73,2.11,2.11,0,0,0-.31.64,25.73,25.73,0,0,0-.52,3.61c-.49,3.76-.07,12.2-.07,12.2h.88l.35-7.66c.13-2.6,2.12.45,2.69,3.25s1.78,5.78,7.48,5.92C134.84,416.58,137.6,416.32,135.92,414.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.42,413.94a10.55,10.55,0,0,0-3.42-1.86h0s-3.72-3.69-5.51-14.8L164.62,396a4.14,4.14,0,0,0-4.43,1.73,2.11,2.11,0,0,0-.31.64,25.73,25.73,0,0,0-.52,3.61c-.49,3.76-.07,12.2-.07,12.2h.88l.35-7.66c.13-2.6,2.12.45,2.69,3.25s1.78,5.78,7.48,5.92C177.34,415.83,180.1,415.57,178.42,413.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.1,385.85l-10.37,1.83c-10.46-26.07-17.9-47.83-23.16-65.89-2.83-9.75-5.19-18.41-6.89-26.1l.32,28.38V388H117.78c-25.61-122-7.46-149.8-7.46-149.8L141,233.09a138.78,138.78,0,0,1,2.57,17.22l1.38,10.17,12,61.87Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.1,385.85l-10.37,1.83c-10.46-26.07-17.9-47.83-23.16-65.89-2.83-9.75-5.19-18.41-6.89-26.1l.32,28.38V388H117.78c-25.61-122-7.46-149.8-7.46-149.8L141,233.09a138.78,138.78,0,0,1,2.57,17.22l1.38,10.17,12,61.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M177.25,203l10.34-10.22s.36-2.74,1.36-3.5,8.1-3.34,9-2.76,2.08,6.3.87,7.35-7.67,2.39-8.33,2.28l-11.19,13.29Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.2,184.35c4.47,2.36,20.3,24.5,22.63,25.6S183,196.59,183,196.59l3,5.12s-14.63,20.67-22.9,19.67-24.1-18.5-24.1-18.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.2,184.35c4.47,2.36,20.3,24.5,22.63,25.6S183,196.59,183,196.59l3,5.12s-14.63,20.67-22.9,19.67-24.1-18.5-24.1-18.5Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.01 197.13 183.25 195.96 186.5 201.46 185.33 203.71 182.01 197.13",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.36,209.34c-3.7-3.53-6.36-6.46-6.36-6.46l.28-4.4,1.39-4.27A17.55,17.55,0,0,1,145.36,209.34Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.57,321.79c-2.83-9.75-5-18.41-6.73-26.1a240.34,240.34,0,0,1,2-27.22S134.31,303.58,134.57,321.79Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7,231.2c1.25-22,.69-34.12.12-40.17-.62-6.45-1.62-6.68-1.62-6.68s-7-.68-13.06-.64a100.07,100.07,0,0,0-14,1.48,93.49,93.49,0,0,0-13,3.13c.71,2,1.35,4,2,5.76.8,2.39,1.51,4.6,2.15,6.67,1.2,3.86,2.14,7.2,2.89,10.2a110.85,110.85,0,0,1,3.32,23s-7.69,20.1-9.19,34.85l25.5,2.75,3.5-14.75,3.5,15.25L148,267Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7,231.2c1.25-22,.69-34.12.12-40.17-.62-6.45-1.62-6.68-1.62-6.68s-7-.68-13.06-.64a100.07,100.07,0,0,0-14,1.48,93.49,93.49,0,0,0-13,3.13c.71,2,1.35,4,2,5.76.8,2.39,1.51,4.6,2.15,6.67,1.2,3.86,2.14,7.2,2.89,10.2a110.85,110.85,0,0,1,3.32,23s-7.69,20.1-9.19,34.85l25.5,2.75,3.5-14.75,3.5,15.25L148,267Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.35,216.33c-.34-1.68-.74-3.47-1.23-5.39-.31-1.22-.65-2.5-1-3.86,1-3.41,2-.74,2-.74A30.79,30.79,0,0,1,108.35,216.33Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.83 191.33 129.5 214 132.5 189.67 126.75 196.88 116.83 191.33",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.5,183.25c-5.66,1.33-7.37,5.88-6.75,10l4.13-1.37a49.2,49.2,0,0,1,13.25,7.25s3.12-5.75,6.12-7.63l4.25.5S130.88,179.88,116.5,183.25Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.5,183.25c-5.66,1.33-7.37,5.88-6.75,10l4.13-1.37a49.2,49.2,0,0,1,13.25,7.25s3.12-5.75,6.12-7.63l4.25.5S130.88,179.88,116.5,183.25Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.78,185.05a6,6,0,0,0-1-.4c-.72-.57-1.6-1.94-1.55-5.28a25.59,25.59,0,0,1,.36-3.9l-9.27-1.73s3.16,6.24.52,10.87c-.91.4-1.45,1-1.35,1.73.69,5.36,12.21,10.54,12.21,10.54S132.38,188.13,126.78,185.05Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.64,175.47a25.59,25.59,0,0,0-.36,3.9c-6.27,0-8.91-5.63-8.91-5.63Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.5,144.88s10.88-1.38,12.88,7.37a13.49,13.49,0,0,1-4.75,13.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.51,149.54c8.06-.44,10.89,3.73,11.94,12,1.31,10.34-.59,17.84-10.79,16.17C106.81,175.46,106.13,150.27,119.51,149.54Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.21,161.38a17.35,17.35,0,0,0,2.53,3.22,2.21,2.21,0,0,1-2.07,1Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.24,161c.06.66-.26,1.23-.7,1.26s-.84-.47-.89-1.13.26-1.23.7-1.26S121.19,160.33,121.24,161Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.17,159.9l1.4-.67S120.94,160.49,120.17,159.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.45,160.21c.06.66-.26,1.23-.7,1.26s-.84-.47-.89-1.13.26-1.23.7-1.26S129.4,159.55,129.45,160.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.38,159.12l1.39-.67S129.15,159.71,128.38,159.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.86,155.43a4.21,4.21,0,0,0-3.43,1.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.686238px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.7,154.77a3.74,3.74,0,0,1,3.25.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.686238px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.45,163.61s3.4-6.83,2.55-11.91c0,0,15.62-7.4,17.29,8.77,0,0,.78-14.48-13.1-14.05s-12.7,20.71-5.21,26.36C113,172.78,109.34,167.88,111.45,163.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.88,144.25s6.62-1.62,8.5.13-11.5,14.12-18.5,15.37c0,0-2.38,7.75-.5,11.38,0,0-7.88-2.75-8.25-14.75S115.38,139.88,121.88,144.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.86,165.24a3.54,3.54,0,0,0-4-3c-2.48.4-3.39,5.6,2.89,6.49C112.66,168.84,113.12,167.94,112.86,165.24Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.38,149s-2.75-7-10.13-6.5-8.5,12-4.62,20.5,1.25,11.25,1.25,11.25,4.12-.5,4.12-8.12a27.44,27.44,0,0,1,.25,4.87s2.75-3.87.13-11.25,5.75-4,5.75-4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.75,145s-3.5,11.25-12.87,14.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.686238px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.38,168.5a6.49,6.49,0,0,0,4.62,1.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.686238px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.38,162.13a1.79,1.79,0,1,1-1.79-1.94A1.86,1.86,0,0,1,125.38,162.13Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69,161.81a1.79,1.79,0,1,1-1.78-1.93A1.87,1.87,0,0,1,131.69,161.81Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.38,162.13s.93-2,2.75-.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.81,162.13s-10-.32-11.18-.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.73,208.83l-.46,25.53a1,1,0,0,0,1.12,1l16.81-1.34a1,1,0,0,0,1-1l.81-25.32a1,1,0,0,0-1.1-1.06l-17.16,1.11A1,1,0,0,0,111.73,208.83Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.73,208.83l-.46,25.53a1,1,0,0,0,1.12,1l16.81-1.34a1,1,0,0,0,1-1l.81-25.32a1,1,0,0,0-1.1-1.06l-17.16,1.11A1,1,0,0,0,111.73,208.83Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.23,209.41l-.46,25.53a1,1,0,0,0,1.12,1.05l16.81-1.33a1,1,0,0,0,1-1l.81-25.31a1,1,0,0,0-1.1-1.07L113.2,208.4A1,1,0,0,0,112.23,209.41Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.23,209.41l-.46,25.53a1,1,0,0,0,1.12,1.05l16.81-1.33a1,1,0,0,0,1-1l.81-25.31a1,1,0,0,0-1.1-1.07L113.2,208.4A1,1,0,0,0,112.23,209.41Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.83,221.58a2.5,2.5,0,1,1-2.5-2.5h.1a2.49,2.49,0,0,0,2.37,2.09A2.69,2.69,0,0,1,123.83,221.58Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.13,229.59l12.3-7.75s.94-2.6,2.08-3.13,8.63-1.51,9.35-.77.67,6.61-.74,7.37-8,.69-8.63.43L97.71,236.31Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.13,188.32S108.17,200,107,210L96.33,227.67,103.5,224l3.25,6.13s-8.25,12.7-18.75,9.7S100.13,188.32,100.13,188.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.13,188.32S108.17,200,107,210L96.33,227.67,103.5,224l3.25,6.13s-8.25,12.7-18.75,9.7S100.13,188.32,100.13,188.32Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.75 223.67 106.83 231.25 107.75 229.08 104.5 222.92 102.75 223.67",
    style: {
      fill: "#5F95FA"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196,192.64a4.62,4.62,0,1,1,4.61-4.62A4.62,4.62,0,0,1,196,192.64Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.11,213H198a24.85,24.85,0,0,1-12.31-3.47l2.51-4.42a19.66,19.66,0,0,0,9.8,2.76Zm12.3-3.7L207.89,205a19.72,19.72,0,0,0,7.16-7.21l4.33,2.49A24.69,24.69,0,0,1,210.41,209.3Zm-33.71-9a24.55,24.55,0,0,1-3.31-12.3h5a19.44,19.44,0,0,0,2.64,9.8Zm41-12.39a19.55,19.55,0,0,0-2.66-9.79l4.32-2.52a24.65,24.65,0,0,1,3.34,12.3ZM181,178.24l-4.32-2.5a24.76,24.76,0,0,1,9-9l2.51,4.32A19.9,19.9,0,0,0,181,178.24ZM207.78,171a19.82,19.82,0,0,0-9.76-2.8L198,163H198a24.82,24.82,0,0,1,12.26,3.47Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.11,213H198a24.85,24.85,0,0,1-12.31-3.47l2.51-4.42a19.66,19.66,0,0,0,9.8,2.76Zm12.3-3.7L207.89,205a19.72,19.72,0,0,0,7.16-7.21l4.33,2.49A24.69,24.69,0,0,1,210.41,209.3Zm-33.71-9a24.55,24.55,0,0,1-3.31-12.3h5a19.44,19.44,0,0,0,2.64,9.8Zm41-12.39a19.55,19.55,0,0,0-2.66-9.79l4.32-2.52a24.65,24.65,0,0,1,3.34,12.3ZM181,178.24l-4.32-2.5a24.76,24.76,0,0,1,9-9l2.51,4.32A19.9,19.9,0,0,0,181,178.24ZM207.78,171a19.82,19.82,0,0,0-9.76-2.8L198,163H198a24.82,24.82,0,0,1,12.26,3.47Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--data-points--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203,194.18a6.16,6.16,0,1,1,6.15-6.16A6.16,6.16,0,0,1,203,194.18Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,194.18a6.16,6.16,0,1,1,6.15-6.16A6.16,6.16,0,0,1,203,194.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.02,
    cy: 188.02,
    r: 10.13,
    transform: "translate(-25.08 344.36) rotate(-76.72)",
    style: {
      fill: "none",
      stroke: "#5F95FA",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 187,
    width: 168,
    height: 2,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,179h-2V167a1,1,0,0,1,.29-.71l61.17-61a1,1,0,0,1,.71-.29H322v2H266.58L206,167.41Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,280H276a1,1,0,0,1-.71-.29l-71-71A1,1,0,0,1,204,208V198h2v9.59L276.41,278H351Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,216H260.83a1,1,0,0,1-.7-.29l-27-26.83,1.41-1.42L261.25,214H301Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.21,188.79l-1.42-1.41,26.91-27.09a1.05,1.05,0,0,1,.71-.29H340v2H299.83Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,138H267.23a1,1,0,0,1-.71-.3l-15.94-16.1,1.42-1.41L267.65,136H426Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.37,106.71,283,105.29l26-26a1,1,0,0,1,.71-.29H393v2H310.08Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.63,329l-40.34-40.33A1,1,0,0,1,260,288V264h2v23.59l40,40Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.54,279.39,290.12,278l26.52-26.69a1.05,1.05,0,0,1,.71-.29H418v2H317.77Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,308H340.17a1,1,0,0,1-.71-.29l-28.17-28.17,1.42-1.41L340.58,306H385Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393,
    cy: 80,
    r: 4.58,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,116.58A10.58,10.58,0,1,1,341.58,106,10.58,10.58,0,0,1,331,116.58Zm0-19.16a8.58,8.58,0,1,0,8.58,8.58A8.59,8.59,0,0,0,331,97.42Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331,
    cy: 106,
    r: 4.58,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.58,137.17a4.58,4.58,0,1,1-4.58-4.59A4.58,4.58,0,0,1,430.58,137.17Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 161,
    r: 4.58,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,198.58A10.58,10.58,0,1,1,401.58,188,10.58,10.58,0,0,1,391,198.58Zm0-19.16a8.58,8.58,0,1,0,8.58,8.58A8.59,8.59,0,0,0,391,179.42Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391,
    cy: 188,
    r: 4.58,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 215,
    r: 4.58,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 252,
    r: 4.58,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,289.42a10.59,10.59,0,1,1,10.58-10.59A10.59,10.59,0,0,1,360,289.42Zm0-19.17a8.59,8.59,0,1,0,8.58,8.58A8.59,8.59,0,0,0,360,270.25Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.58,278.83a4.58,4.58,0,1,1-4.58-4.58A4.59,4.59,0,0,1,364.58,278.83Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385,
    cy: 307,
    r: 4.58,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.92,328.33a4.59,4.59,0,1,1-4.59-4.58A4.6,4.6,0,0,1,305.92,328.33Z",
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.56,
    y: 67.75,
    width: 19.72,
    height: 25.75,
    rx: 1.51,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.56,
    y: 67.75,
    width: 19.72,
    height: 25.75,
    rx: 1.51,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.5,
    y: 71.41,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.5,
    y: 73.84,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.5,
    y: 76.28,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.5,
    y: 78.71,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.5,
    y: 81.15,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.5,
    y: 83.59,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.5,
    y: 86.02,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.5,
    y: 88.46,
    width: 8.96,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.64,
    y: 204.29,
    width: 19.72,
    height: 25.75,
    rx: 1.51,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.64,
    y: 204.29,
    width: 19.72,
    height: 25.75,
    rx: 1.51,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 207.94,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 210.38,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 212.81,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 215.25,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 217.68,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 220.12,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 222.56,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 224.99,
    width: 8.96,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 232,
    width: 19.72,
    height: 25.75,
    rx: 1.51,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 232,
    width: 19.72,
    height: 25.75,
    rx: 1.51,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.94,
    y: 235.66,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.94,
    y: 238.09,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.94,
    y: 240.53,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.94,
    y: 242.97,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.94,
    y: 245.4,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.94,
    y: 247.84,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.94,
    y: 250.27,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.94,
    y: 252.71,
    width: 8.96,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.82,
    y: 117.12,
    width: 19.72,
    height: 25.75,
    rx: 1.51,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.82,
    y: 117.12,
    width: 19.72,
    height: 25.75,
    rx: 1.51,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.76,
    y: 120.78,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.76,
    y: 123.21,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.76,
    y: 125.65,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.76,
    y: 128.09,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.76,
    y: 130.52,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.76,
    y: 132.96,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.76,
    y: 135.39,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.76,
    y: 137.83,
    width: 8.96,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.01,
    y: 323.21,
    width: 19.72,
    height: 25.75,
    rx: 1.51,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.01,
    y: 323.21,
    width: 19.72,
    height: 25.75,
    rx: 1.51,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.95,
    y: 326.87,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.95,
    y: 329.3,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.95,
    y: 331.74,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.95,
    y: 334.17,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.95,
    y: 336.61,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.95,
    y: 339.05,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.95,
    y: 341.48,
    width: 13.83,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.95,
    y: 343.92,
    width: 8.96,
    height: 1.39,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.94,
    y: 164.45,
    width: 46,
    height: 46,
    rx: 1.54,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.94,
    cy: 187.45,
    r: 15.5,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.94,187.45h15.5A15.48,15.48,0,1,1,436.69,174Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.94,
    cy: 187.45,
    r: 12,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.94,
    cy: 187.45,
    r: 12,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(423.71 189.79)",
    style: {
      fontSize: "5.888110160827637px",
      fill: "#fff",
      fontFamily: "Bebas",
      letterSpacing: "0.021975562228919342em"
    }
  }, "8", /*#__PURE__*/React.createElement("tspan", {
    x: 3.24,
    y: 0,
    style: {
      letterSpacing: "0.00008292664992045034em"
    }
  }, "0%")), /*#__PURE__*/React.createElement("rect", {
    x: 373.85,
    y: 261.5,
    width: 35,
    height: 35,
    rx: 1.17,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 290.63,
    width: 4.5,
    height: 2.29,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 267.78,
    width: 4.5,
    height: 2.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 271.59,
    width: 4.5,
    height: 2.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 275.4,
    width: 4.5,
    height: 2.29,
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 279.2,
    width: 4.5,
    height: 2.29,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 283.01,
    width: 4.5,
    height: 2.29,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 286.82,
    width: 4.5,
    height: 2.29,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.88,
    y: 290.63,
    width: 4.5,
    height: 2.29,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.88,
    y: 279.2,
    width: 4.5,
    height: 2.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.88,
    y: 283.01,
    width: 4.5,
    height: 2.29,
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.88,
    y: 286.82,
    width: 4.5,
    height: 2.29,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.75,
    y: 290.63,
    width: 4.5,
    height: 2.29,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.75,
    y: 275.4,
    width: 4.5,
    height: 2.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.75,
    y: 279.2,
    width: 4.5,
    height: 2.29,
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.75,
    y: 283.01,
    width: 4.5,
    height: 2.29,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.75,
    y: 286.82,
    width: 4.5,
    height: 2.29,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.63,
    y: 290.63,
    width: 4.5,
    height: 2.29,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.63,
    y: 283.01,
    width: 4.5,
    height: 2.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.63,
    y: 286.82,
    width: 4.5,
    height: 2.29,
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.08,
    y: 93.08,
    width: 35,
    height: 35,
    rx: 1.17,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.11,106.78v-2.19l-1.13-.1a5.66,5.66,0,0,0-.84-2l.72-.88L364.32,100l-.88.73a5.73,5.73,0,0,0-2-.84l-.11-1.13h-2.19l-.1,1.13a5.78,5.78,0,0,0-2,.84l-.87-.73-1.55,1.55.72.88a6,6,0,0,0-.84,2l-1.12.1v2.19l1.12.11a6.13,6.13,0,0,0,.84,2l-.72.88,1.55,1.55.87-.73a5.78,5.78,0,0,0,2,.84l.1,1.13h2.19l.11-1.13a5.73,5.73,0,0,0,2-.84l.88.73,1.54-1.55-.72-.88a5.73,5.73,0,0,0,.84-2Zm-6.89,1.87a3,3,0,1,1,3-3A3,3,0,0,1,360.22,108.65Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,113v-1.72l-.88-.08a4.66,4.66,0,0,0-.66-1.59l.57-.68-1.21-1.22-.69.57a4.61,4.61,0,0,0-1.58-.66l-.09-.88h-1.71l-.09.88a4.61,4.61,0,0,0-1.58.66l-.69-.57-1.21,1.22.57.68a4.47,4.47,0,0,0-.66,1.59l-.89.08V113l.89.08a4.42,4.42,0,0,0,.66,1.58l-.57.69,1.21,1.21.69-.56a4.59,4.59,0,0,0,1.58.65l.09.89h1.71l.09-.89a4.59,4.59,0,0,0,1.58-.65l.69.56,1.21-1.21-.57-.69a4.61,4.61,0,0,0,.66-1.58Zm-5.4,1.46a2.33,2.33,0,1,1,2.33-2.32A2.32,2.32,0,0,1,370.58,114.43Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.11,117.84V116.4l-.74-.07a3.89,3.89,0,0,0-.56-1.34l.48-.57-1-1-.58.48a3.59,3.59,0,0,0-1.33-.56l-.07-.74h-1.44l-.07.74a3.73,3.73,0,0,0-1.33.56l-.57-.48-1,1,.47.57a3.87,3.87,0,0,0-.55,1.34l-.74.07v1.44l.74.07a3.9,3.9,0,0,0,.55,1.33l-.47.57,1,1,.57-.47a3.9,3.9,0,0,0,1.33.55l.07.74h1.44l.07-.74a3.74,3.74,0,0,0,1.33-.55l.58.47,1-1-.48-.57a3.92,3.92,0,0,0,.56-1.33Zm-4.54,1.23a1.95,1.95,0,1,1,1.95-1.95A2,2,0,0,1,362.57,119.07Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.94,
    y: 150.75,
    width: 30.75,
    height: 20,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.94,
    y: 150.75,
    width: 30.75,
    height: 20,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.06,
    y: 154.5,
    width: 28.5,
    height: 15.25,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.38,
    y: 156.78,
    width: 21.08,
    height: 0.66,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.38,
    y: 158.79,
    width: 10.12,
    height: 0.66,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.38,
    y: 160.8,
    width: 12.74,
    height: 0.66,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.38,
    y: 162.81,
    width: 4.49,
    height: 0.66,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.38,
    y: 164.82,
    width: 2.91,
    height: 0.66,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.94,
    y: 303.25,
    width: 30.75,
    height: 20,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.94,
    y: 303.25,
    width: 30.75,
    height: 20,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.06,
    y: 307,
    width: 28.5,
    height: 15.25,
    style: {
      fill: "#5F95FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.38,
    y: 309.28,
    width: 21.08,
    height: 0.66,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.38,
    y: 311.29,
    width: 10.12,
    height: 0.66,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.38,
    y: 313.3,
    width: 12.74,
    height: 0.66,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.38,
    y: 315.31,
    width: 4.49,
    height: 0.66,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.38,
    y: 317.32,
    width: 2.91,
    height: 0.66,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 187,
    width: 170,
    height: 2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,179h-2V167a1,1,0,0,1,.29-.71l61.17-61a1,1,0,0,1,.71-.29H322v2H266.58L206,167.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,280H276a1,1,0,0,1-.71-.29l-71-71A1,1,0,0,1,204,208V198h2v9.59L276.41,278H351Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,216H260.83a1,1,0,0,1-.7-.29l-27-26.83,1.41-1.42L261.25,214H301Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.21,188.79l-1.42-1.41,26.91-27.09a1.05,1.05,0,0,1,.71-.29H340v2H299.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,138H267.23a1,1,0,0,1-.71-.3l-15.94-16.1,1.42-1.41L267.65,136H426Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.37,106.71,283,105.29l26-26a1,1,0,0,1,.71-.29H393v2H310.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.63,329l-40.34-40.33A1,1,0,0,1,260,288V264h2v23.59l40,40Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.54,279.39,290.12,278l26.52-26.69a1.05,1.05,0,0,1,.71-.29H418v2H317.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,308H340.17a1,1,0,0,1-.71-.29l-28.17-28.17,1.42-1.41L340.58,306H385Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393,
    cy: 80,
    r: 4.58,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,116.58A10.58,10.58,0,1,1,341.58,106,10.58,10.58,0,0,1,331,116.58Zm0-19.16a8.58,8.58,0,1,0,8.58,8.58A8.59,8.59,0,0,0,331,97.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.58,137.17a4.58,4.58,0,1,1-4.58-4.59A4.58,4.58,0,0,1,430.58,137.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 161,
    r: 4.58,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,198.58A10.58,10.58,0,1,1,401.58,188,10.58,10.58,0,0,1,391,198.58Zm0-19.16a8.58,8.58,0,1,0,8.58,8.58A8.59,8.59,0,0,0,391,179.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 215,
    r: 4.58,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 252,
    r: 4.58,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,289.42a10.59,10.59,0,1,1,10.58-10.59A10.59,10.59,0,0,1,360,289.42Zm0-19.17a8.59,8.59,0,1,0,8.58,8.58A8.59,8.59,0,0,0,360,270.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385,
    cy: 307,
    r: 4.58,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.92,328.33a4.59,4.59,0,1,1-4.59-4.58A4.6,4.6,0,0,1,305.92,328.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,199.65A11.63,11.63,0,1,1,216.65,188,11.63,11.63,0,0,1,205,199.65Zm0-20.26a8.63,8.63,0,1,0,8.63,8.63A8.64,8.64,0,0,0,205,179.39Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatapointsRafiki);
export default __webpack_public_path__ + "static/media/Data points-rafiki.90467ec6b54ebc7f04b65bb5865847a3.svg";
export { ForwardRef as ReactComponent };